/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react';
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import { PrimaryButton, Spinner, SpinnerSize
} from '@fluentui/react';
import _ from "lodash"
import { useSelector } from 'react-redux';
import PeopleSelectWithGroups from '../../../../UiKit/SharedComponents/PeopleSelectWithGroups';

const pickerContainer = css`
    height: 80vh;
`;
const container = css`
    .ms-DetailsRow-fields{
        width:100%;
    }
`;
function CreateChat(props) {
    const [toList, setToList] = React.useState([]);
    const [creating, setCreating] = React.useState(false);
   
    const { facilityId,} = useSelector(state => ({
        facilityId: state.appState.product.facility.facilityID,
    }));

    const create = () => {
        if (creating) {
            return;
        }
        setCreating(true);
        var model = {
            to: toList.map(x => x.userId),
            facilityId: facilityId
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/CreateChat", model)
            .then((response) => {
                var data = response.data;
                debugger
                props.callback(2, 1, data.chatID, data)
            });
    }
    const setSelected = (items) => {
        setToList(items)
    }

    return (
        <div className="chat-list" css={ container }>
            <div className="flexcolumn mb10 flex1 ml5 " css={pickerContainer}>
                <PeopleSelectWithGroups height="calc(-300px + 100vh)" maxHeight="calc(80vh - 50px)" callback={setSelected} selected={toList.map(x => x.userId)} />
            </div>
            
            {(toList.length > 0) &&
                <div className="footer">
                <form className="displayflex width100 " style={{ justifyContent: 'flex-end' }} onSubmit={(e) => create(e)}>
                    {creating &&
                        <Spinner size={SpinnerSize.medium} className="mr5" />
                    }
                        <PrimaryButton
                            text="Create"
                            onClick={(e) => create(e)}
                    />
                    </form>
                </div>
            }
                
        </div>
    );
    
}

export default CreateChat;

